import { Alert, CardSwitch, If } from "@consumidor-positivo/aurora";
import classNames from "classnames";

import { useEmailResubscriptionSwitch } from "./hooks";

import { Toast } from "@libs/acp/components/Toast";

import "./styles.scss";

type EmailResubscriptionSwitchProps = {
	shouldShowAlert?: boolean;
	absolutePosition?: boolean;
	id: string;
	location: "notificationBar" | "myAccount";
};

export const EmailResubscriptionSwitch = ({
	shouldShowAlert,
	absolutePosition,
	id,
	location,
}: EmailResubscriptionSwitchProps) => {
	const {
		isActiveResubSwitch,
		hasUnsubscribedCommunication,
		resubStatus,
		handleResubscribeCommunication,
	} = useEmailResubscriptionSwitch();

	const cardSwitchContainerClassNames = classNames("", {
		// "full-padding": location === "notificationBar",
		"no-top-padding": location === "myAccount",
	});

	return (
		<>
			<If condition={hasUnsubscribedCommunication}>
				<div className={cardSwitchContainerClassNames}>
					<CardSwitch
						isActive={isActiveResubSwitch}
						label="Quero receber notificações sobre novidades e lembretes via e-mail."
						activateCallBack={handleResubscribeCommunication}
						id={id}
						disabled={isActiveResubSwitch}
						shouldFadeOutAfterActivate={resubStatus === "success"}
					/>
				</div>
			</If>

			<If condition={Boolean(!hasUnsubscribedCommunication && shouldShowAlert)}>
				<div className={cardSwitchContainerClassNames}>
					<Alert
						status="info"
						text="Para cancelar o recebimento de notificações ou mensagens, siga as instruções no rodapé dos nossos e-mails."
					/>
				</div>
			</If>

			<If condition={resubStatus === "success"}>
				<Toast
					title="Tudo certo, você vai receber nossas notificações via e-mail."
					absolutePosition={absolutePosition}
					type="success"
				/>
			</If>

			<If condition={resubStatus === "error"}>
				<Toast
					title="Ops, não conseguimos reescrever seu email novamente. Tente novamente mais tarde."
					absolutePosition={absolutePosition}
					type="error"
				/>
			</If>
		</>
	);
};
